export type RoleId =
  | ""
  | "engineering-manager"
  | "cto-vp-eng"
  | "senior-staff-ic"
  | "recruiter"
  | "other";

export interface Role {
  id: RoleId;
  label: string;
}

export const roles: Role[] = [
  { id: "", label: "What's your role? (optional)" },
  { id: "engineering-manager", label: "Engineering Manager" },
  { id: "cto-vp-eng", label: "CTO / VP Engineering" },
  { id: "senior-staff-ic", label: "Senior / Staff Engineer (interviewer)" },
  { id: "recruiter", label: "Recruiter / Talent" },
  { id: "other", label: "Other" },
];
